<template>
    <div>
        <v-container class="py-10">
            <v-row>
                <v-col cols="12" md="8">
                    <div class="my-2 d-md-none">
                        <a :href="`/${slug}`" style="text-decoration: none;">
                            <v-icon size="xs" color="secondary" class="mb-1">mdi-arrow-left</v-icon> <span class="secondary--text">volver</span>
                        </a>
                    </div>
                    <v-row>
                        <v-col
                            cols="12"
                            md="3"
                            class="order-2 order-md-1"
                        >
                            <v-row no-gutters align="center" justify="center">
                                <v-col cols="4" md="12" v-for="(item, index) in galleryProd" :key="index">
                                    <v-card
                                        max-width="55"
                                        class="mb-5 mx-auto"
                                        @click="changePreview(item.img)"
                                    >
                                        <v-img
                                            :src="item.img"
                                        ></v-img>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col
                            cols="12"
                            md="9"
                            class="order-1 order-md-2"
                        >
                            <v-card>
                                <v-img
                                    :src="bannerProd"
                                ></v-img>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>

                <v-col cols="12" md="4">
                    <div>
                        <v-row>
                            <v-col cols="12">
                                <div class="mb-2 d-none d-md-block">
                                    <a :href="`/${slug}`" style="text-decoration: none;">
                                        <v-icon size="xs" color="secondary" class="mb-1">mdi-arrow-left</v-icon> <span class="secondary--text">volver</span>
                                    </a>
                                </div>
                                
                                <h1 class="font-weight-light mb-0 text-sm-h3 text-h5 mb-5" :class="fontFamily" :style="{'color':titleCardColor}">
                                    {{ storeShowName ?? nameProd }}
                                </h1>

                                <v-divider></v-divider>

                                <!-- options -->
                                <template v-for="(row, j) in optionsProd">
                                    <div :key="j" class="py-3">
                                        {{ row.title }}
                                    </div>
                                    <v-alert
                                        :key="j+1*150"
                                        dense
                                        tile
                                        outlined
                                        type="error"
                                        v-if="showAlertRequired && row.isRequired"
                                    >Debe seleccionar una opción para continuar</v-alert>
                                    <!-- multiple -->
                                    <v-list dense :key="j+10" v-if="row.type == 'multiple'">
                                        <!-- select quantity -->
                                        <template dense>
                                            <v-list-item :disabled="!opt.available" v-for="(opt) in row.values" :key="opt.name">
                                                <v-list-item-content>
                                                    <v-list-item-title>{{ opt.name }} <small>{{ opt.available ? '' : '(no disponible)' }}</small></v-list-item-title>
                                                    <v-list-item-subtitle v-if="(+opt.price)>0">{{ money }} (+{{ opt.price }})</v-list-item-subtitle>
                                                </v-list-item-content>

                                                <div class="d-flex align-center mr-3" v-if="row.ifQuantity">
                                                    <v-btn
                                                        small
                                                        :disabled="opt.quantity<=0"
                                                        @click="changeQtyMultiple(row, opt, -1)"
                                                    >
                                                        <v-icon dark>
                                                            mdi-minus
                                                        </v-icon>
                                                    </v-btn>
                                                    <v-sheet
                                                        height="28"
                                                        width="60"
                                                        class="sheet-cant"
                                                    >
                                                        {{ opt.quantity }}
                                                    </v-sheet>
                                                    <v-btn
                                                        small
                                                        :disabled="(opt.quantity<=0 && (row.tmpVal).length >= row.select) || (row.selectQuantity && row.values.reduce((t, o) => t + (+o.quantity || 0), 0) >= row.selectQuantity)"
                                                        @click="changeQtyMultiple(row, opt, 1)"
                                                    >
                                                        <v-icon dark>
                                                            mdi-plus
                                                        </v-icon>
                                                    </v-btn>
                                                </div>

                                                <span :id="`${opt.name.replace(' ', '-')}_${opt.price}`" :data-details="`${opt.name}:${opt.price}:${(row.quantities)?(opt.quantity*quantity):opt.quantity}`"></span>

                                                <!-- con cantidad, la selección se hace con +/- (cantidad > 0 = seleccionado) -->
                                                <v-list-item-action v-if="!row.ifQuantity">
                                                    <v-checkbox
                                                        v-model="row.tmpVal"
                                                        :value="`${opt.name.replace(' ', '-')}_${opt.price}`"
                                                        :color="btnColor"
                                                        :disabled=" ((row.tmpVal).includes(`${opt.name.replace(' ', '-')}_${opt.price}`)) ? false : ((row.tmpVal).length >= row.select) "
                                                        @change="changeRespMultiple"
                                                    ></v-checkbox>
                                                </v-list-item-action>
                                            </v-list-item>
                                        </template>
                                    </v-list>
                                    <!-- multiple end -->
                                    <!-- only -->
                                    <v-list dense :key="j+20" v-if="row.type == 'only'">
                                        <v-list-item-group
                                            v-model="row.tmpValOnly"
                                            active-class=""
                                            @change="beforeChangeRespOnly(row, $event)"
                                        >
                                            <v-list-item :disabled="!opt.available" v-for="(opt) in row.values" :key="opt.name" :value="opt.name+':'+((row.quantities)?(opt.price*quantity):opt.price)">
                                                <template v-slot:default="{ active }">
                                                        <v-list-item-content>
                                                            <v-list-item-title>
                                                                {{ opt.name }} <small>{{ opt.available ? '' : '(no disponible)' }}</small>
                                                                <span class="error--text" v-if="outOfStock[row.id] == `${row.id}-${slugify(opt.name)}`">(agotado)</span>
                                                            </v-list-item-title>
                                                            <v-list-item-subtitle v-if="(+opt.price)>0">{{ money }} (+{{ opt.price }})</v-list-item-subtitle>
                                                        </v-list-item-content>

                                                        <v-list-item-action>
                                                            <v-icon :color="btnColor" v-if="active">
                                                                mdi-circle-slice-8
                                                            </v-icon>
                                                            <v-icon v-else>
                                                                mdi-checkbox-blank-circle-outline
                                                            </v-icon>
                                                        </v-list-item-action>
                                                    </template>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                    <!-- only end -->
                                </template>
                                
                                <v-divider></v-divider>

                                <!-- services -->
                                <v-card v-if="typeProd=='service'" tile elevation="0">
                                    <v-card-text class="pa-0">
                                        <v-card-title class="py-3 blue-grey lighten-5">
                                            Reserva tu hora
                                        </v-card-title>
                                        <v-form ref="refService" lazy-validation class="pa-3">
                                            <v-row>
                                                <v-col cols="6">
                                                    <v-text-field
                                                        label="Nombre completo *"
                                                        :color="btnColor"
                                                        outlined
                                                        dense
                                                        v-model="fullName"
                                                        :rules="[rules.required]"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-text-field
                                                        label="Número de celular *"
                                                        :color="btnColor"
                                                        outlined
                                                        dense
                                                        v-model="phoneNumber"
                                                        type="number"
                                                        :rules="[rules.required, rules.min]"
                                                    >
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-dialog
                                                        ref="dialog"
                                                        v-model="menu1"
                                                        :return-value.sync="dateFormatted"
                                                        persistent
                                                        width="290px"
                                                    >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <!-- @blur="dateReservation = parseDate(dateFormatted)" -->
                                                        <v-text-field
                                                            v-model="dateFormatted"
                                                            label="Fecha *"
                                                            append-icon="mdi-calendar"
                                                            dense
                                                            outlined
                                                            readonly
                                                            :color="btnColor"
                                                            :rules="[rules.required]"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            v-model="dateReservation"
                                                            locale="es-Bo"
                                                            :color="btnColor"
                                                            class="ma-0"
                                                            scrollable
                                                        >
                                                            <v-spacer></v-spacer>
                                                            <v-btn
                                                                text
                                                                :color="btnColor"
                                                                @click="menu1 = false"
                                                            >
                                                                Cancelar
                                                            </v-btn>
                                                            <v-btn
                                                                :color="btnColor"
                                                                :style="`color:${textbtnColor}`"
                                                                @click="$refs.dialog.save(formatDate(dateReservation))"
                                                            >
                                                                OK
                                                            </v-btn>
                                                        </v-date-picker>
                                                    </v-dialog>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-dialog
                                                        ref="dialog2"
                                                        v-model="menu2"
                                                        :return-value.sync="timeReservation"
                                                        persistent
                                                        width="290px"
                                                    >
                                                        <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            v-model="timeReservation"
                                                            label="Hora *"
                                                            append-icon="mdi-clock-time-four-outline"
                                                            readonly
                                                            outlined
                                                            dense
                                                            :color="btnColor"
                                                            :rules="[rules.required]"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        ></v-text-field>
                                                        </template>
                                                        <v-time-picker
                                                            v-if="menu2"
                                                            v-model="timeReservation"
                                                            full-width
                                                            :color="btnColor"
                                                            class="ma-0"
                                                        >
                                                            <!-- format="24hr" -->
                                                            <v-spacer></v-spacer>
                                                            <v-btn
                                                                text
                                                                :color="btnColor"
                                                                @click="menu2 = false"
                                                            >
                                                                Cancelar
                                                            </v-btn>
                                                            <v-btn
                                                                :color="btnColor"
                                                                :style="`color:${textbtnColor}`"
                                                                @click="$refs.dialog2.save(timeReservation)"
                                                            >
                                                                OK
                                                            </v-btn>
                                                        </v-time-picker>
                                                    </v-dialog>
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-card-text>
                                </v-card>

                                <div class="px-3 pt-5">
                                    <v-textarea
                                        outlined
                                        :placeholder="(typeProd=='service')?'Incluir un comentario para la reserva':'Dato extra'"
                                        :color="btnColor"
                                        rows="2"
                                        hide-details
                                        v-model="dataExtra"
                                    ></v-textarea>
                                </div>

                                <v-card-title class="py-3 blue-grey lighten-5" v-if="enablePaymentMethod && typeProd=='service'">
                                    Método de pago
                                </v-card-title>
                                <div class="pa-3" v-if="enablePaymentMethod && typeProd=='service'">
                                    <div class="text-center">
                                        <v-img
                                            :src="codePaymentMethod"
                                            max-width="300px"
                                            class="mx-auto mb-2"
                                        ></v-img>
                                        <!-- <a :href="codePaymentMethod" download :style="`color: ${btnColor}`">Descargar QR</a> -->
                                        <v-btn
                                            :href="codePaymentMethod"
                                            download
                                            :color="btnColor"
                                            dark
                                            small
                                            class="mb-2"
                                        >
                                            Descargar QR
                                        </v-btn>
                                        <p class="mb-0">Banco: {{ payment.bank }}</p>
                                        <p class="mb-0">Cuenta: {{ payment.account }}</p>
                                        <p class="mb-0">Nombre: {{ payment.name }}</p>
                                        <p class="mb-10">NIT: {{ payment.nit }}</p>
                                    </div>
                                </div>
                            </v-col>
                            <!-- actions -->
                            <v-col
                                cols="12"
                                sm="12"
                            >
                                <v-card-actions class="pa-actions" v-if="!emergency">
                                    <!-- product -->
                                    <v-row align="center" v-if="typeProd=='product'">
                                        <v-col cols="12">
                                            <div class="d-flex align-center" v-if="funCart">
                                                <v-btn small @click="changePlusAndMinus('minus')" :disabled="quantity<=1">
                                                    <v-icon dark>
                                                        mdi-minus
                                                    </v-icon>
                                                </v-btn>
                                                <v-text-field
                                                    placeholder="Cantidad"
                                                    :color="btnColor"
                                                    outlined
                                                    dense
                                                    type="number"
                                                    min="1"
                                                    step="1"
                                                    :max="stock"
                                                    hide-details
                                                    v-model="quantity"
                                                    disabled
                                                    class="text-center in-center"
                                                    @input="changeQuantity($event)"
                                                ></v-text-field>
                                                <v-btn small @click="changePlusAndMinus('plus')" :disabled="quantity>=stock">
                                                    <v-icon dark>
                                                        mdi-plus
                                                    </v-icon>
                                                </v-btn>
                                            </div>
                                        </v-col>
                                        <v-col cols="12">
                                            <template v-if="funCart">
                                                <v-btn
                                                    large
                                                    block
                                                    rounded
                                                    :color="btnColor"
                                                    :style="`color:${textbtnColor}`"
                                                    @click="addToCart"
                                                    class="text-capitalize"
                                                    :disabled="disabledBtn"
                                                >
                                                    <strong>Agregar {{ money }} {{ (quantity * price) + respMultipleVal + respOnlyVal }}</strong>
                                                </v-btn>
                                            </template>
                                            <v-btn
                                                dark
                                                large
                                                block
                                                rounded
                                                v-if="consultWps"
                                                color="#43bf51"
                                                class="text-capitalize mt-2"
                                                :href="`https://wa.me/${codePhone}${storePhone}?text=Hola!%20${storeName},%20quisiera%20realizar%20una%20consulta%20sobre%0a--->%20${nameProd}%20https://${tempHost}/${slug}?product=${prodId}%0a`"
                                                target="_blank"
                                                :disabled="disabledBtn"
                                            >
                                                <strong>Consultar</strong>
                                                <v-icon right>
                                                    mdi-whatsapp
                                                </v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    <!-- services -->
                                    <v-row no-gutters align="center" v-if="typeProd=='service'">
                                        <v-col cols="12" v-if="tempMode=='order_generate'">
                                            <v-btn
                                                large
                                                block
                                                rounded
                                                :color="btnColor"
                                                :style="`color:${textbtnColor}`"
                                                class="text-capitalize mb-2"
                                                @click="openPreviewReservation"
                                            >Generar reserva</v-btn>
                                            <v-btn
                                                dark
                                                large
                                                block
                                                rounded
                                                v-if="consultWps"
                                                color="#43bf51"
                                                class="text-capitalize mt-2"
                                                :href="`https://wa.me/${codePhone}${storePhone}?text=Hola!%20${storeName},%20quisiera%20realizar%20una%20consulta%20sobre%0a--->%20${nameProd}%20https://${tempHost}/${slug}?product=${prodId}%0a`"
                                                target="_blank"
                                            >
                                                <strong>Consultar</strong>
                                                <v-icon right>
                                                    mdi-whatsapp
                                                </v-icon>
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="12" v-else>
                                            <v-btn
                                                large
                                                block
                                                rounded
                                                :color="btnColor"
                                                :style="`color:${textbtnColor}`"
                                                @click="sendServices"
                                                class="text-capitalize"
                                                :loading="loadingServ"
                                            >
                                                <strong>Reservar</strong>
                                            </v-btn>
                                            <v-btn
                                                dark
                                                large
                                                block
                                                rounded
                                                v-if="consultWps"
                                                color="#43bf51"
                                                class="text-capitalize mt-2"
                                                :href="`https://wa.me/${codePhone}${storePhone}?text=Hola!%20${storeName},%20quisiera%20realizar%20una%20consulta%20sobre%0a--->%20${nameProd}%20https://${tempHost}/${slug}?product=${prodId}%0a`"
                                                target="_blank"
                                            >
                                                <strong>Consultar</strong>
                                                <v-icon right>
                                                    mdi-whatsapp
                                                </v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card-actions>
                            </v-col>
                        </v-row>
                    </div>
                </v-col>
                <v-col cols="12">
                    <v-card elevation="0" outlined shaped color="grey lighten-5">
                        <v-card-text>
                            <div>
                                <!-- details -->
                                <div v-if="descriptionProd!='' && descriptionProd!='null' && descriptionProd!=null" class="mb-3">
                                    <div :style="{'color':contentColor, 'fontSize':'16px'}">
                                        <div v-html="descriptionProd"></div>
                                    </div>
                                </div>
                                <!-- extra button -->
                                <div class="px-0 py-2" style="width:100%" v-if="extraBtn.isBtn">
                                    <v-btn
                                        rounded
                                        :color="btnColor"
                                        class="text-capitalize"
                                        v-if="extraBtn.typeBtn == 'url'"
                                        :href="extraBtn.urlBtn"
                                        target="_blank"
                                        :style="`color:${textbtnColor}`"
                                    >{{ extraBtn.textBtn }}</v-btn>
                                    <v-btn
                                        rounded
                                        :color="btnColor"
                                        class="text-capitalize"
                                        v-if="extraBtn.typeBtn == 'video'"
                                        @click="dialogVideo = true, codeVideo = extraBtn.urlBtn"
                                        :style="`color:${textbtnColor}`"
                                    >{{ extraBtn.textBtn }}</v-btn>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <!-- video -->
        <v-dialog
            v-model="dialogVideo"
            width="800"
            scrollable
            transition="dialog-bottom-transition"
        >
            <v-card>
                <v-btn
                    fab
                    small
                    absolute
                    right
                    style="z-index:1;top:10px;"
                    @click="dialogVideo = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <iframe width="100%" :height="($vuetify.breakpoint.smAndUp)?500:300" :src="`https://www.youtube.com/embed/${codeVideo}?rel=0&showinfo=0&controls=0&autoplay=1&autohide=0&loop=1`" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </v-card>
        </v-dialog>
        <!-- video END -->
    </div>
</template>
<script>
export default {
    data() {
        return {
            tempHost: window.location.host,
            overlayProd: false,
            loadProd: true,
            dialogProd: false,
            prodId: '',
            bannerProd: '',
            galleryProd: [],
            nameProd: '',
            storeShowName: '',
            typeProd: '',
            descriptionProd: '',
            optionsProd: [],
            quantity: 1,
            price: null,
            tmpPrice: null,
            priceNormal: null,
            stock: 500,
            dataExtra: '',
            respMultiple: [],
            respMultipleVal: 0,
            respOnly: [],
            respOnlyVal: 0,
            showRequired: false,
            showAlertRequired: false,
            extraBtn: {},
            dialogVideo: false,
            codeVideo: '',
            // reservation
            menu1: false,
            menu2: false,
            fullName: '',
            phoneNumber: '',
            dateReservation: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            dateFormatted: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
            timeReservation: '14:00',
            loadingServ: false,
            // validation
            rules: {
                required: v => !!v || 'El campo es requerido',
                requiredDates: v => v.length>0 || 'El campo es requerido',
                min: v => v.length >= 8 || 'Mínimo 8 caracteres',
                phone: v => (v.length >= 8 && v.length <= 8) || 'Debe contener 8 dígitos',
                email: v => /.+@.+\..+/.test(v) || 'Correo electrónico inválido'
            },
            // generate
            dialogGenerate: false,
            contentOrder: '',
            // qr code
            enablePaymentMethod: false,
            codePaymentMethod: '',
            payment: {
                bank: '',
                account: '',
                name: '',
                nit: ''
            },
            wholesalePrices: [],
            extraComplement: [],
            tmpCombination: {},
            disabledBtn: false,
            tmpPriceCombination: null,
            outOfStock: []
        }
    },
    props: [
        'slug',
        'productId',
        'titleColor',
        'titleCardColor',
        'priceColor',
        'btnColor',
        'textbtnColor',
        'bannerColor',
        'textnavColor',
        'navColor',
        'fontFamily',
        'dataMyStore',
        'consultWps',
        'storePhone',
        'codePhone',
        'storeName',
        'emergency',
        'money',
        'ifLoadMore',
        'contentColor',
        'tempMode',
        'searchProd',
        'loading2',
        'to',
        'total',
        'mobileColumns',
        'desktopColumns',
        'funCart',
        'locationMap',
        'typeStore',
        'inventory',
        'openProductNewTab'
    ],
    mounted() {
        this.openDetails(this.productId)
    },
    methods: {
        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        changePreview(url) {
            this.bannerProd = url;
        },
        openDetails(id) {
            this.loadProd = true
            this.wholesalePrices = []
            this.tmpCombination = {}
            this.disabledBtn = false
            // this.dialogProd = true
            axios.get(`/show-product/${id}?store=${this.slug}`)
            .then((response) => {
                // console.log(response);
                this.prodId = response.data.id
                const tmpBanner = response.data.banner.split('/');
                this.bannerProd = (tmpBanner.slice(-1)[0]!='img-default.png') ? response.data.banner : 'none'
                // this.galleryProd.push({id:0, img:this.bannerProd})
                this.galleryProd = [...[{id:0, img:this.bannerProd}], ...response.data.gallery]
                this.nameProd = response.data.name
                this.storeShowName = response.data.store_show_name

                this.typeProd = response.data.type
                this.descriptionProd = response.data.description
                if (response.data.complements.length > 0) {
                    response.data.complements.forEach(element => {
                        var tmpVal = JSON.parse(element.values)
                        var multiRequired = []
                        var onlyRequired = undefined
                        tmpVal.forEach(val => {
                            // multiple con cantidad empieza en 0 (no seleccionado)
                            val.quantity = (element.type == 'multiple' && element.quantity) ? 0 : 1
                        });
                        if (element.type == 'multiple') {
                            for (let i = 0; i < tmpVal.length; i++) {
                                const val = tmpVal[i];
                                if (element.required) {
                                    val.quantity = 1
                                    // multiRequired.push(`${val.name}:${val.price}:${val.quantity}`)
                                    multiRequired.push(`${val.name.replace(' ', '-')}_${val.price}`)
                                    setTimeout(() => {
                                        this.changeRespMultiple()
                                    }, 300);
                                    break
                                }
                            }
                        }
                        if (element.type == 'only') {
                            for (let i = 0; i < tmpVal.length; i++) {
                                const val = tmpVal[i];
                                if (element.required) {
                                    onlyRequired = val.name+':'+val.price
                                    setTimeout(() => {
                                        this.changeRespOnly()
                                    }, 300);
                                    break
                                }
                            }
                        }
                        // const selectRequired = `${opt.name.replace(' ', '-')}_${opt.price}`
                        this.optionsProd.push({
                            id: element.id,
                            title: element.title,
                            type: element.type,
                            values: tmpVal,
                            select: element.select,
                            selectQuantity: (+element.select_quantity > 0) ? +element.select_quantity : null,
                            tmpVal: multiRequired,
                            tmpValOnly: onlyRequired,
                            ifQuantity: element.quantity,
                            quantity: 1,
                            isRequired: (element.required)?true:false,
                            quantities: (element.quantities)?true:false
                        })
                        if (element.required) {
                            this.showRequired = true
                        }
                    });
                }
                this.price = (response.data.special_price) ? response.data.special_price : response.data.price
                this.tmpPrice = (response.data.special_price) ? response.data.special_price : response.data.price
                this.tmpPriceCombination = (response.data.special_price) ? response.data.special_price : response.data.price
                this.priceNormal = response.data.price??0;
                this.quantity = 1
                if (response.data.stock > 0) {
                    this.stock = response.data.stock
                }

                // extra boton
                this.extraBtn = {
                    isBtn: response.data.btn_extra,
                    textBtn: response.data.text_btn_extra,
                    typeBtn: response.data.type_btn_extra,
                    urlBtn: response.data.url_btn_extra
                }

                // precios por mayor
                this.wholesalePrices = response.data.wholesale_prices ? JSON.parse(response.data.wholesale_prices) : []

                // extra complements
                if (response.data.extra_complements.length > 0) {
                    this.extraComplements = JSON.parse(response.data.extra_complements[0].values)
                }

                this.dialogProd = true
                setTimeout(() => {
                    this.loadProd = false
                }, 800);
            })
            .catch((error) => {
                console.log(error);
            })
        },
        /**
         * before
         */
        slugify(text) {
            return text
                .toString()
                .normalize("NFD")                   // separa los acentos de las letras
                .replace(/[\u0300-\u036f]/g, "")    // elimina los acentos
                .toLowerCase()                      // convierte a minúsculas
                .trim()                             // elimina espacios al inicio y final
                .replace(/\s+/g, '-')               // reemplaza espacios por guiones
                .replace(/[^\w\-]+/g, '')           // elimina caracteres no alfanuméricos excepto guiones
                .replace(/\-\-+/g, '-');            // reemplaza múltiples guiones por uno solo
        },
        async verifyStock(barcode) {
            let stk = 0
            let prc = 0
            await axios.post('/verify-stock', {barcode: barcode, slug: this.slug})
            .then((response) => {
                // console.log(response);
                stk = response.data?.internal_stock
                prc = (response.data?.special_price && response.data?.special_price > 0) ? response.data?.special_price : response.data?.price
            })
            .catch((error) => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
            return {
                stock: stk,
                price: prc
            }
        },
        async beforeChangeRespOnly(row, e) {
            this.outOfStock = []
            if (this.typeStore == 'product' && (+this.inventory) && this.extraComplements) {
                const idsComplements = [...new Set(this.extraComplements.map(el => el.ids).flat())]
                if (idsComplements.includes(row.id)) {
                    // obtener el valor seleccionado
                    this.tmpCombination[row.id] = e.split(':')[0]
                    // convertir el objeto en un array
                    const arrayComplements = Object.values(this.tmpCombination)
                    // ordenar el array
                    const arrayOrderComplements = [...arrayComplements].sort((a, b) => a.length - b.length)

                    // encontrar el complemento extra
                    const fiindExtraComplement = this.extraComplements.find(item => 
                        JSON.stringify(item.names.sort((a, b) => a.length - b.length)) === JSON.stringify(arrayOrderComplements)
                    )

                    if (fiindExtraComplement) {
                        // asignar el complemento extra
                        if (fiindExtraComplement.barcode=='') {
                            this.disabledBtn = true
                            this.price = this.tmpPriceCombination

                            this.outOfStock[row.id] = `${row.id}-${this.slugify(e.split(':')[0])}`
                        } else {
                            const stkprc = await this.verifyStock(fiindExtraComplement.barcode)
                            const stk = stkprc.stock
                            const prc = stkprc.price
                            
                            if (stk > 0) {
                                this.disabledBtn = false
                                this.price = prc
                                this.priceNormal = prc
                                // if (fiindExtraComplement.price != '') {
                                //     this.price = +fiindExtraComplement.price
                                // } else {
                                //     this.price = this.tmpPriceCombination
                                // }
                            } else {
                                this.outOfStock = []
                                this.disabledBtn = true
                                this.price = this.tmpPriceCombination
                                this.outOfStock[row.id] = `${row.id}-${this.slugify(e.split(':')[0])}`
                            }
                        }
                    }
                }
            }
            this.changeRespOnly()
        },
        changeRespOnly() {
            this.verifyRequireds()
            const tmpListOnly = []
            this.optionsProd.forEach(element => {
                if (element.tmpValOnly) {
                    tmpListOnly.push(element.tmpValOnly)
                }
            });

            this.respOnlyVal = 0
            if (tmpListOnly.length > 0) {
                tmpListOnly.forEach(el => {
                    let tmpPrice = +(el.split(':')[1])
                    this.respOnlyVal += tmpPrice
                });
            }
            // console.log(tmpListOnly);
            this.respOnly = tmpListOnly
        },
        verifyRequireds() {
            this.showRequired = false
            for (let i = 0; i < this.optionsProd.length; i++) {
                const element = this.optionsProd[i];
                //console.log(this.optionsProd);
                //console.log(element);
                //console.log(`title: ${element.title} | type: ${element.type} | tmpValOnly: ${element.tmpValOnly}`);
                if (element.isRequired) {
                    if (element.type == 'multiple') this.showRequired = (element.tmpVal.length<=0)
                    if (element.type == 'only') this.showRequired = (element.tmpValOnly==undefined)
                }
                if (this.showRequired) break
            }
        },
        /**
         * 
         */
        addToCart() {
            this.showAlertRequired = false
            if (this.showRequired) {
                this.showAlertRequired = true
                return
            }
            this.overlayProd = true
            const cart = {
                    prodId: this.prodId,
                    name: this.nameProd,
                    // price: this.price,
                    price: (this.quantity * this.price) + this.respMultipleVal + this.respOnlyVal,
                    priceNormal: (this.quantity * this.priceNormal) + this.respMultipleVal + this.respOnlyVal,
                    quantity: this.quantity,
                    extra: this.dataExtra,
                    complements: {
                        multi: this.respMultiple,
                        only: this.respOnly
                    },
                    complementsTitles: this.getComplementsTitles()
                }

            if (localStorage.getItem(this.slug)) {
                const tmpCart = JSON.parse(localStorage.getItem(this.slug))
                var size = Object.keys(tmpCart).length;
                tmpCart[size] = cart
                // tmpCart[this.prodId] = cart
                localStorage.setItem(this.slug, JSON.stringify(tmpCart))
            } else {
                let tmpCartInitial = {}
                tmpCartInitial[0] = cart
                // tmpCartInitial[this.prodId] = cart
                localStorage.setItem(this.slug, JSON.stringify(tmpCartInitial))
            }

            this.$emit('update-cart', localStorage.getItem(this.slug))

            setTimeout(() => {
                this.overlayProd = false
                this.dialogProd = false
            }, 300);
            setTimeout(() => {
                this.$confirm(
                    '',
                    'Producto agregado correctamente.',
                    'success', {
                    showCloseButton: true,
                    reverseButtons: true,
                    confirmButtonText: 'Ver carrito',
                    confirmButtonColor: this.btnColor,
                    cancelButtonText: 'Seguir comprando',
                    customClass: {
                        container: this.tmpFontFamily
                    }
                }).then(res => {
                    if (res) {
                        this.$emit('open-cart', true)
                    }
                });
            }, 500);
        },
        // change plus and minus
        changePlusAndMinus(type) {
            var tmpImport = 0
            switch (type) {
                case 'minus':
                    tmpImport = ((+this.price) * ((+this.quantity)-1))
                    if (tmpImport < 0) {
                        this.$notify.error('Error, el importe esperado no debe ser menor a cero, revise el campo descuento por favor.')
                        return
                    }
                    this.quantity = (+this.quantity) - 1
                    break
                case 'plus':
                    tmpImport = ((+this.price) * ((+this.quantity)+1))
                    if (tmpImport < 0) {
                        this.$notify.error('Error, el importe esperado no debe ser menor a cero, revise el campo descuento por favor.')
                        return
                    }
                    this.quantity = (+this.quantity) + 1
                    break
                default:
                    break
            }

            this.updateQuantitysComplements()

            this.changeQuantity(this.quantity)
            this.calcTotal()
        },
        updateQuantitysComplements() {
            this.optionsProd.forEach(element => {
                if (element.quantities) {
                    if (element.tmpValOnly) {
                        let tmp = element.tmpValOnly.split(':')
                        element.values.forEach(item => {
                            if (item.name == tmp[0]) tmp[1] = item.price
                        });
                        tmp[1] = tmp[1]*this.quantity
                        element.tmpValOnly = tmp.join(':')
                    }
                    if (element.tmpVal.length > 0) {
                        element.tmpVal.forEach(val => {
                            const selectedId = document.getElementById(val)
                            const dataSelected = selectedId.getAttribute('data-details')
                            let tmp2 = dataSelected.split(':')
                            element.values.forEach(item => {
                                if (item.name == tmp2[0]) tmp2[1] = item.price
                            });
                            tmp2[1] = tmp2[1]*this.quantity
                            selectedId.setAttribute('data-details', tmp2.join(':'))
                        });
                    }
                }
            });
            this.changeRespOnly()
            this.changeRespMultiple()
        },
        getComplementsTitles() {
            // nombre de la opción -> título del complemento, para los mensajes de WhatsApp
            const titles = { multi: {}, only: {} }
            this.optionsProd.forEach(row => {
                const group = (row.type == 'multiple') ? titles.multi : titles.only
                row.values.forEach(opt => {
                    // nombre:precio distingue opciones homónimas entre complementos; el nombre queda como respaldo
                    group[`${opt.name}:${opt.price}`] = row.title
                    group[opt.name] = row.title
                })
            })
            return titles
        },
        changeQtyMultiple(row, opt, step) {
            const key = `${opt.name.replace(' ', '-')}_${opt.price}`
            const newQty = Math.max(0, opt.quantity + step)
            // respetar la cantidad máxima de todos los complementos juntos
            if (step > 0 && row.selectQuantity && row.values.reduce((t, o) => t + (+o.quantity || 0), 0) + step > row.selectQuantity) return
            const isSelected = row.tmpVal.includes(key)

            if (newQty > 0 && !isSelected) {
                // respetar el máximo de opciones permitidas
                if (row.tmpVal.length >= row.select) return
                row.tmpVal.push(key)
            }
            if (newQty == 0 && isSelected) {
                row.tmpVal.splice(row.tmpVal.indexOf(key), 1)
            }

            opt.quantity = newQty
            this.changeRespMultiple()
        },
        changeRespMultiple() {
            this.verifyRequireds()
            setTimeout(() => {
                var tmpListComplements = []
                this.optionsProd.forEach(element => {
                    element.tmpVal.forEach(val => {
                        const selectedId = document.getElementById(val)
                        const dataSelected = selectedId.getAttribute('data-details')
                        tmpListComplements.push(dataSelected)
                    });
                });
                // console.log(tmpListComplements);
                this.respMultipleVal = 0
                if (tmpListComplements.length > 0) {
                    tmpListComplements.forEach(el => {
                        // console.log(el);
                        let valSelected = el.split(':')
                        let tmpPrice = (+valSelected[1]) * (+valSelected[2])
                        this.respMultipleVal += tmpPrice
                    });
                }
                this.respMultiple = tmpListComplements
            }, 500);
        },
        changeQuantity(event) {
            if (+event <= 1) {
                this.quantity = 1
            }
            if (+event > this.stock) {
                this.$fire({
                    title: 'Agotado',
                    text: `Stock agotado, solo queda ${this.stock} productos en almacén`,
                    type: 'error',
                    confirmButtonText: 'Entendido',
                    confirmButtonColor: this.btnColor,
                    cancelButtonColor: '#f44336',
                    reverseButtons: true,
                    showCancelButton: false,
                    customClass: {
                        container: this.fontFamily
                    }
                }).then(resp => {
                    if (resp.value) {
                        this.quantity = this.stock
                        this.calcTotal()
                    }
                })
            }
            this.calcTotal()
        },
        // calc total
        calcTotal() {
            // this.total = 0
            // this.listProdSelected.forEach(p => {
            //     this.total+=(p.price * p.quantity) - p.discount
            // });
            // this.data.payTotal = this.total.toFixed(2)
        },
    },
}
</script>